export default "__VITE_ASSET__D5Z2jWze__"